import AppPageHeader from '@/components/_common/AppPageHeader';
import { RequestPurchasesQuery } from '@/core/domain/workorder/RequestPurchase/RequestPurchase.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Col, Input, Row } from 'antd';

type Props = ExtraFiltersProps<RequestPurchasesQuery>;

const FiltersItemsRequestPurchase: React.FC<Props> = ({
  queryParams,
  setQueryParams,
}) => {
  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      extraFilters={
        <Row gutter={8}>
          <Col span={24} md={12}>
            <Input
              placeholder="Código do fabricante"
              value={queryParams?.manufacturingCodeFilter}
              onChange={({ target: { value } }) =>
                setQueryParams((prev) => ({
                  ...prev,
                  manufacturingCodeFilter: value,
                }))
              }
            />
          </Col>
        </Row>
      }
    />
  );
};

export default FiltersItemsRequestPurchase;
